module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_MT-d05345408f7e7f7485386c20c35df1b6.svg";